/**
 * Order Search Utilities
 */

import { generateSearchQuery } from "@/utils/search";

/**
 * Generate search query for orders
 */
export const generateOrdersSearchQuery = (searchText: string): string => {
  return generateSearchQuery(searchText, [
    "name",
    "ordernumber",
    "dogma_ordernumber",
    "description",
    "dogma_internalpo",
    "dogma_evolutionjobnumber",
    "quoteid/customerid_contact/fullname",
    "quoteid/dogma_projectreference",
    "quoteid/dogma_Customer_account/name",
  ]);
};

/**
 * Generate region filter query for orders
 * Filters by customer region through quote relationship
 */
export const generateRegionFilterQuery = (region?: number): string => {
  if (region === null || region === undefined || region === 0) {
    return "";
  }
  return `quoteid/dogma_region eq ${region}`;
};
